import { useCallback, useEffect, useRef, useState } from 'react';

type Status = 'idle' | 'analyzing' | 'done';

export function useAnalyze() {
  const [status, setStatus] = useState<Status>('idle');
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clearTimers = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const start = useCallback(() => {
    clearTimers();
    setStatus('analyzing');
    setProgress(0);

    intervalRef.current = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return prev;
        return Math.min(prev + Math.floor(Math.random() * 8) + 3, 95);
      });
    }, 400);
  }, [clearTimers]);

  const finish = useCallback(() => {
    clearTimers();
    setProgress(100);
    setStatus('done');
  }, [clearTimers]);

  const reset = useCallback(() => {
    clearTimers();
    setStatus('idle');
    setProgress(0);
  }, [clearTimers]);

  useEffect(() => clearTimers, [clearTimers]);

  return {
    status: status,
    progress: progress,
    isAnalyzing: status === 'analyzing',
    isDone: status === 'done',
    start: start,
    finish: finish,
    reset: reset,
  };
}
